import { useEffect } from "react";
import { useRFFormContext } from "../../../components/Form/RFForm";
import RFField from "../../../components/Form/RFField";
import CustomTooltip from "../../../components/Tooltip/CustomTooltip";

const MusorContentOsszetettKeresesFormField = ({
  eloszuresKereses,
  onChange,
}) => {
  const { change } = useRFFormContext();

  useEffect(() => {
    change("eloszuresKereses", eloszuresKereses);
  }, [eloszuresKereses]);

  return (
    <RFField
      label={"Összetett keresés:"}
      name="eloszuresKereses"
      id="eloszuresKereses"
      value={eloszuresKereses}
      onChange={onChange}
      hideFormGroup
      required
      tooltip={
        <CustomTooltip
          text={"Élő foglalások között keres, a még nem elmúlt eseményekben"}
          id="eloszuresKereses"
          style={{ marginLeft: 2, marginBottom: 2 }}
        />
      }
    />
  );
};

export default MusorContentOsszetettKeresesFormField;
